import { Box, Link, List, ListItem, ListItemText, Typography } from '@mui/material';
import { getContactEmail } from '../../utils/env';

const PrivacyPolicyPage = () => {
  const contactEmail = getContactEmail();

  return (
    <Box display="flex" flexDirection="column" gap={3}>
      <Typography variant="h4" fontWeight={700} gutterBottom>
        Política de Privacidade
      </Typography>
      <Typography color="text.secondary">
        Esta política descreve quais dados coletamos, como usamos e como protegemos as informações
        dos usuários da {process.env.REACT_APP_SITE_NAME}.
      </Typography>

      <Box>
        <Typography variant="h6">Dados que coletamos</Typography>
        <List dense>
          <ListItem>
            <ListItemText primary="Cadastro: nome, e-mail e, opcionalmente, telefone." />
          </ListItem>
          <ListItem>
            <ListItemText primary="Autenticação: IDs de login social (Google/Microsoft) ou tokens de link mágico/OTP." />
          </ListItem>
          <ListItem>
            <ListItemText primary="Uso e segurança: logs de acesso para prevenção a fraudes e auditoria." />
          </ListItem>
          <ListItem>
            <ListItemText primary="Pagamentos: dados mínimos para processar transações e repasses (não armazenamos dados completos de cartão)." />
          </ListItem>
        </List>
      </Box>

      <Box>
        <Typography variant="h6">Como usamos os dados</Typography>
        <List dense>
          <ListItem>
            <ListItemText primary="Autenticar usuários (Google/Microsoft, link mágico, OTP)." />
          </ListItem>
          <ListItem>
            <ListItemText primary="Operar listas de presentes, pagamentos e notificações solicitadas pelo usuário." />
          </ListItem>
          <ListItem>
            <ListItemText primary="Prevenir abusos, cumprir requisitos legais e de segurança." />
          </ListItem>
        </List>
      </Box>

      <Box>
        <Typography variant="h6">Compartilhamento</Typography>
        <Typography color="text.secondary">
          Não vendemos dados pessoais. Compartilhamos apenas com provedores necessários para operar
          a plataforma (hospedagem, e-mail, pagamentos), sob termos de proteção de dados.
        </Typography>
      </Box>

      <Box>
        <Typography variant="h6">Retenção e seus direitos</Typography>
        <List dense>
          <ListItem>
            <ListItemText primary="Mantemos dados enquanto a conta estiver ativa ou conforme exigência legal." />
          </ListItem>
          <ListItem>
            <ListItemText primary="Você pode solicitar acesso, correção ou exclusão, quando aplicável." />
          </ListItem>
        </List>
      </Box>

      <Box>
        <Typography variant="h6">Segurança</Typography>
        <Typography color="text.secondary">
          Usamos criptografia em trânsito, controle de acesso e práticas de segurança comuns do
          setor. Nenhum método é 100% seguro, mas trabalhamos continuamente para proteger seus
          dados.
        </Typography>
      </Box>

      <Box>
        <Typography variant="h6">Contato</Typography>
        <Typography color="text.secondary">
          Em caso de dúvidas, fale com a gente:{' '}
          <Link href={`mailto:${contactEmail}`}>{contactEmail}</Link>.
        </Typography>
      </Box>
    </Box>
  );
};

export default PrivacyPolicyPage;
